import * as React from 'react';
import {withNamespaces, WithNamespaces} from "react-i18next";
import EditorDivider from "../EditorDivider";

interface OwnProps {
  content: React.ReactNode;
  label: string;
  isAggregate: boolean;
}

type BusinessRulesEditorDividerProps = OwnProps & WithNamespaces;

const BusinessRulesEditorDivider = (props: BusinessRulesEditorDividerProps) => {
  return <EditorDivider label={props.label} content={props.content} popupContent={<>
    <p>{props.t('insp.cody_wizard.editor.businessRules.help1')}</p>
    <p>{props.t('insp.cody_wizard.editor.businessRules.help2')}</p>
    <p>{props.t('insp.cody_wizard.editor.contextVariables')}</p>
    <ul>
      <li>command: command data</li>
      <li>meta: command metadata</li>
      {props.isAggregate && <li>information: aggregate state</li>}
      <li>Command Dependencies</li>
    </ul>
    <p>{props.t('insp.cody_wizard.editor.autocomplete')}</p>
    <p><a href="https://wiki.prooph-board.com/board_workspace/Rule-Engine.html#business-rules"
          onClick={e => e.stopPropagation()}
          target="_blank"
          rel="nofollow">{props.t('app.learnMore')}</a></p>
  </>}/>
};

export default withNamespaces()(BusinessRulesEditorDivider);
